import { QUESTION_IDS } from '../enums/questionIds';

const initialState = {
    questions: [],
    answers: {},
    plans: [],
    loading: false,
    error: null,
    loadingAnswers: false,
    loadingPlans: false,
    userAnswersArchivo:[],
    juryAnswers: [],
};

export const questionReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_ALL_QUESTIONS':
            return {
                ...state,
                loading: true
            };
        case 'GET_ALL_QUESTIONS_SUCCESS':
            return {
                ...state,
                loading: false,
                questions: action.payload
            };
        case 'GET_ALL_QUESTIONS_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case 'GET_ALL_CAREER_PLANS':
            return {
                ...state,
                loadingPlans: true
            };
        case 'GET_ALL_CAREER_PLANS_SUCCESS':
            return {
                ...state,
                loadingPlans: false,
                plans: action.payload
            };
        case 'GET_ALL_CAREER_PLANS_ERROR':
            return {
                ...state,
                loadingPlans: false,
                error: action.payload
            };
        case 'GET_ALL_JURY_ANSWERS':
        case 'GET_ALL_ANSWERS':
            return {
                ...state,
                loadingAnswers: true
            };
        case 'GET_ALL_USER_ANSWERS_ARCHIVO_SUCCESS':
            // Filtrar solo las respuestas de tipo archivo
            const archivos = action.payload.filter(
                answer => answer.preguntaAsociada?.idTipo === '9215c5f0-e70a-4ed5-be51-ec0040c92e63'
            );
            return {
                ...state,
                userAnswersArchivo: archivos, // Solo archivos filtrados
            };
        case 'GET_ALL_ANSWERS_SUCCESS':
            const formattedAnswers = {};
            const ID_MICRO = QUESTION_IDS.ID_MICRO;
            const ID_DESTINATARIOS = QUESTION_IDS.ID_DESTINATARIOS;
            const ID_ARTICULACION = QUESTION_IDS.ID_ARTICULACION;

            action.payload.forEach(answer => {
                const questionId = answer.preguntaAsociada.Id.toLowerCase();
                if (questionId === ID_DESTINATARIOS || questionId === ID_ARTICULACION) {
                    // Lógica multipleAnswers para destinatarios y articulación
                    if (formattedAnswers[questionId]) {
                        formattedAnswers[questionId].multipleAnswers.push({
                            answerId: answer.Id,
                            answer: answer.respuesta,
                            observacion: answer.observacion,
                            questionId: questionId,
                        });
                    } else {
                        formattedAnswers[questionId] = {
                            multipleAnswers: [
                                {
                                    answerId: answer.Id,
                                    answer: answer.respuesta,
                                    observacion: answer.observacion,
                                    questionId: questionId
                                }
                            ]
                        };
                    }
                } else {
                    // Lógica original para el resto
                    formattedAnswers[questionId] = {
                        answerId: answer.Id,
                        answer: answer.respuesta,
                        observacion: answer.observacion,
                        questionId: questionId,
                        tags: answer.tags || []
                    };
                }
            });
            return {
                ...state,
                loadingAnswers: false,
                answers: formattedAnswers
            };
        case 'GET_ALL_ANSWERS_ERROR':
            return {
                ...state,
                loadingAnswers: false,
                error: action.payload
            };
        case 'GET_ALL_JURY_ANSWERS_ERROR':
            return {
                ...state,
                loading: false,
                loadingAnswers: false,
                error: action.payload,
            };
        case 'GET_ALL_JURY_ANSWERS_SUCCESS':
            return {
                ...state,
                juryAnswers: action.payload,
                loading: false,
                error: null,
            };
        case 'SET_ANSWER':
            // Si el cuarto parámetro es un array, lo guardo como multipleAnswers
            if (Array.isArray(action.payload.answerId)) {
                return {
                    ...state,
                    answers: {
                        ...state.answers,
                        [action.payload.questionId]: {
                            multipleAnswers: action.payload.answerId
                        }
                    }
                };
            }
            // Si no, lógica original
            return {
                ...state,
                answers: {
                    ...state.answers,
                    [action.payload.questionId]: {
                        answer: action.payload.answer,
                        observacion: action.payload.observacion,
                        answerId: action.payload.answerId
                    }
                }
            };
        case 'SET_ANSWER_MULTIPLE':
            const currentAnswers = state.answers[action.payload.grandQuestionIdM] || {};
            const multipleAnswers = currentAnswers.multipleAnswers || [];
            
            // Verificar si ya existe una respuesta con el mismo questionId
            const existingIndex = multipleAnswers.findIndex(
                a => a.questionId === action.payload.questionIdM
            );
            
            let updatedMultipleAnswers;
            if (existingIndex >= 0) {
                // Actualizar la respuesta existente
                updatedMultipleAnswers = multipleAnswers.map((answer, index) => 
                    index === existingIndex 
                        ? {
                            ...answer,
                            answer: action.payload.answerM,
                            observacion: action.payload.observacionM
                        }
                        : answer
                );
            } else {
                // Agregar nueva respuesta
                updatedMultipleAnswers = [
                    ...multipleAnswers,
                    {
                        questionId: action.payload.questionIdM,
                        answer: action.payload.answerM,
                        observacion: action.payload.observacionM
                    }
                ];
            }
            
            return {
                ...state,
                answers: {
                    ...state.answers,
                    [action.payload.grandQuestionIdM]: {
                        answer: action.payload.grandQuestionAnswer,
                        multipleAnswers: updatedMultipleAnswers
                    }
                }
            };
        case 'SAVE_ANSWER_SUCCESS':
            return {
                ...state,
                loading: false
            };
        case 'SAVE_ANSWER_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case 'DELETE_ANSWER_SUCCESS':
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
